export const EMPTY_SETTING = {
  phrase_theme: "",
  description: "",
  examples: [],
}